import { render, staticRenderFns } from "./projectOutRecords.vue?vue&type=template&id=c24821a6&scoped=true&"
import script from "./projectOutRecords.vue?vue&type=script&lang=js&"
export * from "./projectOutRecords.vue?vue&type=script&lang=js&"
import style0 from "./projectOutRecords.vue?vue&type=style&index=0&id=c24821a6&lang=less&scoped=true&"
import style1 from "./projectOutRecords.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24821a6",
  null
  
)

component.options.__file = "projectOutRecords.vue"
export default component.exports